import fetch from "@lib/fetch";
import type { Queries } from "@lib/serializeQueryObjects";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalWorkflows } from "./constants";
import type {
  ConversationalWorkflowsParams,
  GetConversationalWorkflowsResult,
  OperatorSafeConversationalWorkflowsResultItem,
  ConversationalWorkflowsResultItem,
} from "./types";
import { isGetConversationalWorkflowsResult } from "./validators";

export const getDataTableConversationalWorkflows = reactQueryTableFetcherAdapter<
  typeof conversationalWorkflows,
  ConversationalWorkflowsParams,
  ConversationalWorkflowsResultItem | OperatorSafeConversationalWorkflowsResultItem,
  GetConversationalWorkflowsResult
>(
  conversationalWorkflows,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      operatorSafe,
    }: ConversationalWorkflowsParams
  ): Promise<GetConversationalWorkflowsResult> => {
    return fetch(
      `/${appGroupId}/conversational/workflows`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query as Queries),
        operator_safe: operatorSafe,
      },
      { signal }
    );
  },
  isGetConversationalWorkflowsResult
);
